import script from "./sf-banner-base.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-banner-base.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__